import { useEffect, useState } from 'react';

import CloseIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';

import { useAppSelector } from '../../../Hooks/useApp';
import { selectCurrentUser } from '../../../State/slices/authentication';
import { selectOwnerProperties } from '../../../State/slices/listing';
import { createPaymentAccount } from '../../../Utils/Payments/flx.payments.api';

export const WhatsNewModal = ({ isOpen = false }: { isOpen: boolean }) => {
  const [open, setOpen] = useState(isOpen);
  const userId = sessionStorage.getItem('userId');
  const [isLoggedIn, setIsLoggedIn] = useState(userId);

  useEffect(() => {
    setIsLoggedIn(userId);
  }, [userId]);

  const user = useAppSelector(selectCurrentUser);
  const onwerPropertiesState = useAppSelector(selectOwnerProperties);

  const isLandlord = onwerPropertiesState.length > 0;

  const landlordCanLease = isLandlord && user?.canLease;

  // Opt landlord into payments
  useEffect(() => {
    if (isLandlord && user && !user.stripeConnectedAccountId) {
      createPaymentAccount(user.email);
    }
  }, [isLandlord, user.stripeConnectedAccountId]);

  const handleClose = () => {
    setOpen(false);
    sessionStorage.setItem('showBetaModalvpayments', 'false');
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby='what-is-new-dialog-title'
      open={open}
      fullWidth
    >
      <DialogTitle id='what-is-new-dialog-title'>What&apos;s New</DialogTitle>
      <IconButton
        aria-label='close'
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <Typography variant='overline' gutterBottom>
          Release 1.3 🎉
        </Typography>
        <Typography component='div' gutterBottom>
          We are releasing native payments!
          <br />
          <br />
          <ul>
            <li>
              <Typography fontWeight='bold'>Native Payments</Typography>
              We&apos;re automating the booking process! When booking a property, you can now
              pay directly through the platform. We have a brief process for approval, and once
              you&apos;re approved, you can pay directly on the platform. Submit your booking
              request, sign the lease, and wait for your approval from the landlord. Once
              approved, you can pay directly through the platform.
            </li>
            {landlordCanLease || !isLoggedIn ? (
              <li>
                <Typography fontWeight='bold'>Property Owners</Typography>Property owners can
                now accept payments directly through the platform. Just jump into the dashboard
                and check out your booking requests. After reviewing the booking request you
                can approve or deny the request. Once approved, the tenant can pay directly
                through the platform. Once the tenant has paid, they will have access to view
                their current stay and given information to communicate directly with you. We
                will opt you into the platform automatically. Next you can go to your Dashboard
                and finish up a few details by logging into the new payment platform and
                finish. After that You&apos;ll be ready to accept payments!
              </li>
            ) : (
              <li>
                <Typography fontWeight='bold'>Contact us</Typography>
                If you are a property owner and would like to accept payments through the
                platform please contact our support team.
              </li>
            )}
          </ul>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Got It!</Button>
      </DialogActions>
    </Dialog>
  );
};
